(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["am-catalog-ordering"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-catalog-ordering')) {
    customElements.define('am-catalog-ordering', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.names = JSON.parse(this.querySelector('[data-am-option-names]').textContent);
        this.options = JSON.parse(this.querySelector('[data-am-initial-options]').textContent);
        customElements.whenDefined('am-personalization').then(() => { if (this.isConnected) this.update(); });
        this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data.sectionId) !== this.dataset.sectionId || !event.data.variant) return;
          const variant = event.data.variant;
          this.options = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
          this.update();
        });
        this.externalChange = (event) => {
          if (!event.target.closest('am-personalization')) this.querySelectorAll('[data-am-confirm]').forEach(input => { input.checked = false; });
        };
        this.form.addEventListener('change', this.externalChange);
      }
      disconnectedCallback() { this.variantUnsubscribe?.(); this.form?.removeEventListener('change', this.externalChange); }
      update() {
        const choice = Object.fromEntries(this.names.map((name, index) => [name.toLowerCase(), this.options[index] || '']));
        const blank = Object.entries(choice).some(([name, value]) => /finish|personaliz|^option|pattern/.test(name) && /^(no|blank)$|no monogram|no personalization|\bblank\b/i.test(value));
        const values = this.options.join(' ').toLowerCase();
        const vinyl = this.dataset.profile === 'vinyl' || /vinyl|glitter/.test(values) || (this.dataset.profile === 'vinyl' && /matte/.test(values));
        const style = choice['monogram style'] || (this.dataset.profile === 'napkins' ? 'Classic interlocking' : '');
        const thread = choice['thread color'] || '';
        const count = this.dataset.profile === 'siblings' ? Math.max(2, Math.min(4, parseInt(choice.sets, 10) || 2)) : 1;
        this.querySelector('[data-am-blank-note]').hidden = !blank;
        this.querySelectorAll('[data-am-catalog-item]').forEach((fieldset) => {
          const active = !blank && Number(fieldset.dataset.amCatalogItem) <= count;
          fieldset.hidden = !active;
          fieldset.disabled = !active;
          fieldset.querySelector('am-personalization')?.applyCatalog?.({ style, thread, vinyl, active, supplyJeans: choice.ordering === 'Complete Package' });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["am-metallic-upgrade"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-metallic-upgrade')) {
    customElements.define('am-metallic-upgrade', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.submit = async (event) => {
          const selected = this.querySelector('[data-am-metallic]');
          if (!selected.checked || selected.matches(':disabled')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.pending) return;
          this.form.querySelectorAll('am-personalization').forEach(component => component.sync());
          if (!this.form.reportValidity()) return;
          this.pending = true;
          const button = this.form.querySelector('[type="submit"]');
          const error = this.querySelector('[data-am-upgrade-error]');
          button.setAttribute('aria-disabled', 'true');
          error.hidden = true;
          try {
            const data = new FormData(this.form);
            const quantity = Number(data.get('quantity') || 1);
            const properties = {};
            for (const [key, value] of data.entries()) {
              if (key.startsWith('properties[') && typeof value === 'string' && value) properties[key.slice(11, -1)] = value;
            }
            const response = await fetch(routes.cart_add_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [
                { id: data.get('id'), quantity, properties },
                { id: this.dataset.variantId, quantity, properties: { 'For item': this.dataset.productTitle, Personalization: properties['Personalization text'] || '' } }
              ] })
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
            window.location.assign(routes.cart_url);
          } catch (failure) {
            error.textContent = failure.message || this.dataset.error;
            error.hidden = false;
            this.pending = false;
            button.removeAttribute('aria-disabled');
          }
        };
        this.form.addEventListener('submit', this.submit, true);
      }
      disconnectedCallback() { this.form?.removeEventListener('submit', this.submit, true); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["am-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-personalization')) {
    customElements.define('am-personalization', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.closest('form');
        this.removeLegacy = () => this.form.querySelectorAll('#infiniteoptions-container').forEach((container) => {
          const apparel = ['chef','oxford','cuff'].includes(this.dataset.catalogProfile);
          if (!apparel) {
            if (!container.hidden) container.hidden = true;
            if (!container.inert) container.inert = true;
            container.querySelectorAll('input,select,textarea').forEach((input) => { if (!input.disabled) input.disabled = true; if (input.required) input.required = false; });
            return;
          }
          const keep = ['properties[Rush Service]'];
          if (this.dataset.catalogProfile === 'chef') keep.push('properties[Size]','properties[Logo Position]','properties[Position of Text]');
          container.querySelectorAll('input,select,textarea').forEach((input) => {
            if (keep.includes(input.name)) return;
            input.disabled = true;
            input.required = false;
            let wrapper = input;
            while (wrapper.parentElement && wrapper.parentElement !== container) wrapper = wrapper.parentElement;
            wrapper.hidden = true;
          });
        });
        this.removeLegacy();
        this.legacyObserver = new MutationObserver(this.removeLegacy);
        this.legacyObserver.observe(this.form, { childList: true, subtree: true });
        this.type = this.querySelector('[data-am-type]');
        this.confirmation = this.querySelector('[data-am-confirm]');
        this.error = this.querySelector('[data-am-error]');
        this.addEventListener('input', (event) => this.update(event));
        this.addEventListener('change', (event) => this.update(event));
        this.form.addEventListener('submit', (event) => {
          this.removeLegacy();
          this.sync();
          const invalid = Array.from(this.querySelectorAll('input,select')).find((field) => !field.disabled && field.willValidate && !field.checkValidity());
          if (invalid) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.error.textContent = this.dataset.error;
            this.error.hidden = false;
            invalid.focus();
            invalid.reportValidity();
          }
        }, true);
        this.mode();
        this.sync();
      }
      disconnectedCallback() { this.legacyObserver?.disconnect(); }
      field(name) { return this.querySelector('[data-am-' + name + ']'); }
      update(event) {
        if (event.target !== this.confirmation) this.confirmation.checked = false;
        if (event.target === this.type || event.target.matches('[data-am-metallic]')) this.mode();
        if (event.target.matches('[data-am-first],[data-am-middle],[data-am-last],[data-am-single]')) event.target.value = event.target.value.toLocaleUpperCase().slice(0,1);
        this.error.hidden = true;
        this.sync();
      }
      applyCatalog(context) {
        this.catalogVariant = context;
        if (!this.ready) return;
        this.confirmation.checked = false;
        this.mode();
        this.sync();
      }
      mode() {
        const variant = this.catalogVariant || {};
        const method = this.field('method');
        if (method) method.value = variant.vinyl ? 'Vinyl' : 'Embroidery';
        const forceRaw = !!this.dataset.catalogProfile && (variant.style || variant.vinyl || ['bride','cuff','heirloom','siblings'].includes(this.dataset.catalogProfile));
        if (forceRaw) this.type.value = 'Exact wording';
        this.type.hidden = forceRaw;
        this.querySelector('[data-am-type-label]').hidden = forceRaw;
        const mode = this.type.value === 'Name' ? 'name' : this.type.value === 'Single initial' ? 'single' : this.type.value === 'Exact wording' ? 'raw' : 'three';
        this.querySelectorAll('[data-am-group]').forEach((group) => {
          const active = group.dataset.amGroup === mode;
          group.hidden = !active;
          if (group.tagName === 'FIELDSET') group.disabled = !active;
          group.querySelectorAll('input').forEach((input) => { input.disabled = !active; input.required = active; });
        });
        this.querySelector('[data-am-monogram-style]').hidden = mode !== 'three';
        this.querySelectorAll('[data-am-style]').forEach((input) => { input.disabled = mode !== 'three'; input.required = mode === 'three'; });
        this.field('lettering').hidden = mode === 'three';
        this.field('lettering-input').disabled = mode === 'three';
        this.field('order').disabled = mode !== 'three';
        const variantStyle = this.querySelector('[data-am-variant-style]');
        if (variantStyle) { variantStyle.hidden = !variant.style; variantStyle.textContent = variant.style; }
        const jeansSize = this.querySelector('[data-am-jeans-size]');
        if (jeansSize) { jeansSize.hidden = !variant.supplyJeans; jeansSize.disabled = !variant.supplyJeans; }
        const alternate = this.querySelector('[data-am-alternate-color]');
        if (alternate) {
          const metallic = this.querySelector('[data-am-metallic]')?.checked;
          const metallicFields = this.querySelector('[data-am-metallic-fields]');
          if (metallicFields) { metallicFields.hidden = !metallic; metallicFields.disabled = !metallic; }
          const useAlternate = variant.vinyl || this.dataset.catalogProfile === 'christmas';
          const useThread = !useAlternate && !variant.thread && !metallic;
          const threadWrapper = this.querySelector('[data-am-thread-wrapper]');
          threadWrapper.hidden = !useThread;
          threadWrapper.disabled = !useThread;
          alternate.hidden = !useAlternate;
          alternate.disabled = !useAlternate;
          const alternateInput = this.field('alternate-color-input');
          if (alternateInput.tagName === 'SELECT') {
            const allowed = variant.vinyl ? ['Elf Green','Ruby Red','Hunter Green','Lime Green'] : ['Red','Lime Green','Ever Green','Hunter Green'];
            [...alternateInput.options].forEach(option => { option.hidden = option.value && !allowed.includes(option.value); option.disabled = !!option.value && !allowed.includes(option.value); });
            if (alternateInput.selectedOptions[0]?.disabled) alternateInput.value = '';
          }
          const variantThread = this.field('variant-thread');
          variantThread.hidden = !variant.thread || useAlternate;
          variantThread.textContent = variant.thread || '';
          const variantInput = this.field('variant-thread-input');
          variantInput.value = variant.thread || '';
          variantInput.disabled = !variant.thread || useAlternate;
        }
      }
      sync() {
        const three = this.type.value === 'Three-letter monogram';
        const name = this.field('name');
        name.setCustomValidity(this.type.value === 'Name' && !name.value.trim() ? this.dataset.error : '');
        ['first','middle','last','single'].forEach((key) => {
          const input = this.field(key);
          input.setCustomValidity(!input.disabled && !/^\p{L}$/u.test(input.value) ? this.dataset.error : '');
        });
        const first = this.field('first').value.toLocaleUpperCase();
        const middle = this.field('middle').value.toLocaleUpperCase();
        const last = this.field('last').value.toLocaleUpperCase();
        const raw = this.field('raw');
        if (raw) raw.setCustomValidity(this.type.value === 'Exact wording' && !raw.value.trim() ? this.dataset.error : '');
        const text = three ? first + last + middle : this.type.value === 'Exact wording' ? raw.value.trim() : this.type.value === 'Name' ? name.value.trim() : this.field('single').value.toLocaleUpperCase();
        this.field('left').textContent = three ? first : '';
        this.field('center').textContent = three ? last : text || '…';
        this.field('right').textContent = three ? middle : '';
        this.field('preview').classList.toggle('is-monogram',three);
        this.field('text').value = text;
        this.field('order').value = three ? this.dataset.orderNote : '';
        const color = this.field('color');
        const selectedColor = color.tagName === 'SELECT' ? color.value : this.querySelector('[data-am-color]:checked')?.value || '';
        let colorLabel = color.tagName === 'SELECT' ? (selectedColor ? color.options[color.selectedIndex].text : '') : this.querySelector('[data-am-color]:checked')?.dataset.colorLabel || '';
        const metallicColor = this.querySelector('[data-am-metallic]:checked') ? this.querySelector('[data-am-metallic-color]')?.value : '';
        if (metallicColor) colorLabel = metallicColor;
        if (this.catalogVariant?.thread) colorLabel = this.catalogVariant.thread;
        const alternateInput = this.field('alternate-color-input');
        if (alternateInput && !alternateInput.closest('fieldset').disabled) colorLabel = alternateInput.value;
        const colorStatus = this.field('color-status');
        if (colorStatus) colorStatus.textContent = colorLabel || colorStatus.dataset.empty;
        const style = this.field('style');
        const selectedStyle = this.catalogVariant?.style || this.querySelector('[data-am-heirloom-style]:checked')?.value || (style.tagName === 'SELECT' ? style.value : this.querySelector('[data-am-style]:checked')?.value || '');
        this.field('summary').textContent = [selectedStyle && (three || this.catalogVariant?.style || this.dataset.catalogProfile === 'heirloom') ? selectedStyle : '', colorLabel].filter(Boolean).join(' · ');
        this.field('approved').disabled = !this.confirmation.checked;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["am-towel-personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('am-towel-ordering')) {
    customElements.define('am-towel-ordering', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.counts = JSON.parse(this.querySelector('[data-am-counts]').textContent);
        this.update(this.form.querySelector('[name="id"]').value);
        this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data.sectionId) === this.dataset.sectionId && event.data.variant) this.update(event.data.variant.id);
        });
      }
      disconnectedCallback() { this.variantUnsubscribe?.(); }
      update(variantId) {
        const count = this.counts[String(variantId)] || Number(this.dataset.initialCount);
        this.querySelectorAll('[data-am-towel]').forEach((fieldset) => {
          const active = Number(fieldset.dataset.amTowel) <= count;
          if (this.count !== count) {
            const confirmation = fieldset.querySelector('[data-am-confirm]');
            if (confirmation) confirmation.checked = false;
          }
          fieldset.hidden = !active;
          fieldset.disabled = !active;
        });
        this.count = count;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
